import { render, staticRenderFns } from "./AdaptiveDialog.vue?vue&type=template&id=28d81618&scoped=true"
import script from "./AdaptiveDialog.vue?vue&type=script&lang=js"
export * from "./AdaptiveDialog.vue?vue&type=script&lang=js"
import style0 from "./AdaptiveDialog.vue?vue&type=style&index=0&id=28d81618&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d81618",
  null
  
)

export default component.exports